import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./contracts.actions"
import { handleError } from "../errorHandler/errorHandler.saga"
import * as notificationActions from "../notifications/notifications.actions"

export function* postContractsFlow(action: actions.PostContractAction): SagaIterator {
  try {
    const { employeeId, ...data } = action.payload
    yield call(api.postContract, employeeId, data)
    yield put(actions.postContractSuccess())
    yield put(actions.getContractsById({ employeeId }))
    yield put(
      notificationActions.show({
        id: "postContractSuccess",
        message: "notifications.contract.post.success",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postContractFail(e))
    yield call(handleError, { error: e })
  }
}

export function* getContractsFlow(action: actions.GetContractsAction): SagaIterator {
  try {
    const { params } = action.payload
    const response = yield call(api.getContracts, params)
    yield put(actions.getContractsSuccess(response.data))
  } catch (e) {
    yield put(actions.getContractsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* getContractsByIdFlow(action: actions.GetContractsByIdAction): SagaIterator {
  try {
    const { employeeId, params } = action.payload
    const response = yield call(api.getContractsByEmployeeId, employeeId, params)
    yield put(actions.getContractsSuccess(response.data))
  } catch (e) {
    yield put(actions.getContractsFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* ContractsSaga(): SagaIterator {
  yield takeLatest(actions.Types.POST, postContractsFlow)
  yield takeLatest(actions.Types.GET, getContractsFlow)
  yield takeLatest(actions.Types.GET_BY_ID, getContractsByIdFlow)
}
